export default __webpack_public_path__ + "static/media/library.d8b2178c.jpg";